import type { GA4_EVENT, GA4EventType } from '@ab-core-functions/google-analytics';
import { pushToDataLayer } from '@ab-core-functions/google-analytics';
import { useIntersectionObserver } from '@ab-core-functions/observer';
import { TEMPLATE_IDS, UC_UI } from '@ab-core-functions/usercentrics';
import { useEffect, useRef } from 'react';

type UseGoogleAnalyticsTrackingImpressionProps = {
    event: GA4_EVENT.VIEW_PROMOTION | GA4_EVENT.VIEW_ITEM;
    params: GA4EventType;
    skip?: boolean;
};

export const useGoogleAnalyticsTrackingImpression = <T extends HTMLElement = HTMLDivElement>(
    props: UseGoogleAnalyticsTrackingImpressionProps
) => {
    const { event, params, skip = false } = props;
    const hasTracked = useRef(false);
    const hasConsent = UC_UI.getConsentByTemplateId(TEMPLATE_IDS.GOOGLE_ANALYTICS);

    const { ref, isVisible } = useIntersectionObserver<T>({
        threshold: 0.5,
        freezeOnceVisible: true
    });

    useEffect(() => {
        if (skip || !hasConsent) {
            return;
        }

        if (isVisible && !hasTracked.current) {
            hasTracked.current = true;
            pushToDataLayer(event, params);
        }
    }, [isVisible, event, params, skip, hasConsent]);

    return { ref, isVisible };
};
